import { useState, type ReactNode } from "react";
import type { ModalsContextType } from "./useModals";
import { ModalsContext } from "./ModalsContext";

export function ModalsProvider({ children }: { children: ReactNode }) {
  const [showSettings, setShowSettings] = useState(false);
  const [showFocus, setShowFocus] = useState(false);
  const [showShortcuts, setShowShortcuts] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const [showAchievements, setShowAchievements] = useState(false);
  const [showTutorial, setShowTutorial] = useState(false);
  const [showTimerSettings, setShowTimerSettings] = useState(false);
  const [showTemplates, setShowTemplates] = useState(false);
  const [showBugReport, setShowBugReport] = useState(false);
  const [settingsScrollTarget, setSettingsScrollTarget] = useState<string | null>(null);

  const value: ModalsContextType = {
    showSettings,
    setShowSettings,
    showFocus,
    setShowFocus,
    showShortcuts,
    setShowShortcuts,
    showAdmin,
    setShowAdmin,
    showAchievements,
    setShowAchievements,
    showTutorial,
    setShowTutorial,
    showTimerSettings,
    setShowTimerSettings,
    showTemplates,
    setShowTemplates,
    showBugReport,
    setShowBugReport,
    settingsScrollTarget,
    setSettingsScrollTarget,
  };

  return (
    <ModalsContext.Provider value={value}>
      {children}
    </ModalsContext.Provider>
  );
}
